import script from "./VideoStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./VideoStylePanel.vue?vue&type=style&index=0&id=802e1e06&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-802e1e06"]])

export default __exports__